module.exports = __webpack_public_path__ + "img/1cc1306.jpg";